var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatusDeadline20Px = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F2994A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5037 10.705C14.4741 8.43053 13.2801 6.33013 11.3408 5.14118C11.0217 4.94356 10.6157 4.95417 10.3073 5.16819C9.99886 5.38221 9.84686 5.75882 9.92031 6.12695C10.1312 7.08307 9.92867 8.0838 9.36259 8.88267C8.93574 8.49813 8.609 8.0154 8.41063 7.47621C8.34948 7.27524 8.19852 7.11402 8.00198 7.03982C7.80545 6.96563 7.58561 6.98685 7.40689 7.09727C6.04849 8.02657 5.32576 9.63899 5.53595 11.2714C5.87759 13.5911 7.94031 15.2617 10.2804 15.1139C12.6205 14.9662 14.4566 13.0493 14.5037 10.705Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatusDeadline20Px);
export default ForwardRef;